import Swiper from 'swiper';

let swiper2colImage = {
    init() {

        var swiper = new Swiper('.swiper-container.swiper-2col-image', {
            loop: true,
            autoplay: {
                delay: 3000,
            },
        });

    }
}

export default swiper2colImage;
